<template>
  <div class="home">
    <main class="main-content">
      <!-- <div class="lang-th" v-if="$i18n.locale !== 'en'"> -->
      <div class="lang-th">
        <div class="page-dtac-at-home">
          <!-- HERO BANNER -->
          <section id="hl_main" class="sc-content-hilight">
            <div class="container">
              <div class="main-hl">
                <div class="hl-txt logo-home">
                  <figure
                    class="wow fadeInUp"
                    data-wow-duration="0.7s"
                    data-wow-delay="0.3s"
                    style="text-align: center;"
                  >
                    <img src="../assets/logo-dtac-home.svg" class="img-fluid" alt />
                    <h3 v-if="$i18n.locale !== 'en'">{{ $t('home_hero.logo_title') }}</h3>
                  </figure>
                  <h2
                    class="bubble wow fadeInUp"
                    data-wow-duration="0.7s"
                    data-wow-delay="0.3s"
                    style="font-size: 28px; line-height: 1.4; padding-top: 8px; padding-bottom: 5px; text-align: center;"
                  >
                    {{ $t('home_hero.logo_description1') }}
                    <br />
                    {{ $t('home_hero.logo_description2') }}
                    <div v-if="$i18n.locale === 'en'">No Extra Cost!</div>
                  </h2>
                  <div
                    class="check-coverage wow fadeInUp"
                    data-wow-duration="0.3s"
                    data-wow-delay="0.3s"
                    style="margin-bottom: 1.5rem; border: 4px"
                  >
                    <div class="mt-2">
                      <button
                        class="btn-round wow zoomIn"
                        data-wow-duration="1s"
                        data-wow-delay="1.5s"
                        @click="navigateToCheckService('banner')"
                      >{{ $t('btn.checklocation') }}</button>
                    </div>
                  </div>
                </div>
                <div class="hl-detail">
                  <div class="box-home">
                    <figure class="wow zoomIn" data-wow-duration="1s" data-wow-delay="1.2s">
                      <img
                        src="../assets/home/images/obj-home3.png"
                        class="img-fluid d-none d-sm-block"
                        style="max-width: 110%;"
                        alt
                      />
                      <img
                        src="../assets/home/images/obj-home3.png"
                        class="img-fluid d-block d-sm-none"
                        alt
                      />
                    </figure>
                  </div>
                  <div
                    class="box-detail wow fadeInRight"
                    data-wow-duration="1s"
                    data-wow-delay="1.8s"
                  >
                    <ul>
                      <li class="model">
                        <div class="wrap-inner">
                          <figure>
                            <img v-if="$i18n.locale !== 'en'" src="../assets/home/images/obj-model-4-TH.png" class="img-fluid" alt />
                            <img v-else src="../assets/home/images/obj-model-4-EN.png" class="img-fluid" alt />
                          </figure>
                        </div>
                      </li>
                      <li class="install">
                        <div class="wrap-inner">
                          <h3>{{ $t('home_hero.benefit1_title') }}</h3>
                          <figure>
                            <img
                              src="../assets/home/images/ico-install@2x.png"
                              class="img-fluid"
                              alt
                            />
                          </figure>
                          <p>
                            <b>
                              <span>{{ $t('home_hero.benefit1_description1') }}</span>
                            </b>
                            <br />
                            {{ $t('home_hero.benefit1_description2') }}
                          </p>
                        </div>
                      </li>
                      <li class="lock-up">
                        <div class="wrap-inner">
                          <h3>{{ $t('home_hero.benefit2_title') }}</h3>
                          <figure>
                            <img src="../assets/home/images/ico-worth@2x.png" class="img-fluid" alt />
                          </figure>
                          <p>
                            {{ $t('home_hero.benefit2_description1') }}
                            <br class="d-none" />
                            <b>{{ $t('home_hero.benefit2_description2') }}</b>
                          </p>
                        </div>
                      </li>
                      <li class="money-back">
                        <div class="wrap-inner">
                          <h3>{{ $t('home_hero.benefit3_title') }}</h3>
                          <figure>
                            <img
                              src="../assets/home/images/ico-guarantee@2x.png"
                              class="img-fluid"
                              alt
                            />
                          </figure>
                          <p>
                            {{ $t('home_hero.benefit3_description1') }}
                            <br />
                            <b>
                              <span>{{ $t('home_hero.benefit3_description2') }}</span>
                            </b>
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <p class="wow fadeInDown" data-wow-duration="1s" data-wow-delay="2.1s">
                    {{ $t('home_hero.footer_title') }}
                    <b>500.-</b>
                    <span>{{ $t('home_hero.footer_ps') }}</span>
                  </p>
                </div>
              </div>
            </div>
          </section>
          <!-- Why Choose Us -->
          <section id="sc_why" class="sc-content-why">
            <span class="curve-white wow fadeInRight" data-wow-duration="1s" data-wow-delay="0.2s"></span>
            <div class="line-3 wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0s">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="container">
              <div class="why-wrapper">
                <h2
                  class="wow fadeInDown"
                  data-wow-duration="0.5s"
                  data-wow-delay="0.3s"
                >{{ $t('home_benefits.header') }}</h2>
                <div class="row" style="align-items: flex-start;">
                  <div class="col-md-7 col-lg-8 d-flex">
                    <b-embed
                      type="video"
                      aspect="16by9"
                      controls
                      poster="vdo-poster.jpg"
                      controlslist="nodownload"
                    >
                      <source src="dtac@Home.mp4" type="video/mp4" />
                    </b-embed>
                  </div>
                  <div
                    class="col-md-5 col-lg-4 d-flex flex-column justify-content-between mt-3 mt-md-0"
                  >
                    <div class="install wow flipInX" data-wow-duration="0.7s" data-wow-delay="0.2s">
                      <div class="wrap-inner">
                        <h3>{{ $t('home_benefits.benefit1_title') }}</h3>
                        <h5>{{ $t('home_benefits.benefit1_subtitle') }}</h5>
                        <p class="mb-0">{{ $t('home_benefits.benefit1_description') }}</p>
                      </div>
                    </div>
                    <div
                      class="lock-up my-3 wow fadeInUp"
                      data-wow-duration="0.7s"
                      data-wow-delay="0.5s"
                    >
                      <div class="wrap-inner">
                        <h3>{{ $t('home_benefits.benefit2_title') }}</h3>
                        <p class="mb-0">{{ $t('home_benefits.benefit2_description') }}</p>
                      </div>
                    </div>
                    <div
                      class="money-back wow fadeInRight"
                      data-wow-duration="0.7s"
                      data-wow-delay="0.8s"
                    >
                      <div class="wrap-inner">
                        <h3>{{ $t('home_benefits.benefit3_title') }}</h3>
                        <h5>{{ $t('home_benefits.benefit3_subtitle') }}</h5>
                        <p class="mb-0">{{ $t('home_benefits.benefit3_description') }}</p>
                      </div>
                    </div>
                    <!-- Check Location BTN -->
                    <div
                      class="check-coverage wow fadeInUp"
                      data-wow-duration="0.3s"
                      data-wow-delay="1.0s"
                      style="margin-top: 1.5rem; text-align: center;"
                    >
                      <div class="mt-2">
                        <button
                          class="btn-round"
                          style="background-color: #ed207b; color: #fff; border-color: #fff;"
                          @click="navigateToCheckService('benefits')"
                        >{{ $t('btn.checklocation') }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- Package Plans -->
          <section id="sc_plan" class="sc-content-plan">
            <div class="container">
              <div class="plan">
                <h2
                  class="wow fadeInDown"
                  data-wow-duration="0.7s"
                  data-wow-delay="0.3s"
                >{{ $t('home_package.header') }}</h2>
                <div
                  class="plan-package postpaid no-footer wow fadeInUp"
                  data-wow-duration="0.3s"
                  data-wow-delay="0.6s"
                >
                  <div
                    class="obj-man wow bounceInUp"
                    data-wow-duration="0.5s"
                    data-wow-delay="0.8s"
                  ></div>
                  <div
                    class="obj-women wow bounceInUp"
                    data-wow-duration="0.5s"
                    data-wow-delay="1s"
                  ></div>
                  <header v-if="$i18n.locale !== 'en'">
                    <h3>
                      <small>{{ $t('home_package.title') }}</small>
                      <b>{{ $t('home_package.monthly') }}</b>
                    </h3>
                    <p>{{ $t('home_package.subtitle') }}</p>
                  </header>
                  <header v-else>
                    <h3>
                      <b>{{ $t('home_package.title') }}</b>
                    </h3>
                    <p>{{ $t('home_package.subtitle') }}</p>
                  </header>
                  <div class="container detail">
                    <div class="row">
                      <div class="col-lg-7">
                        <div class="wrap-inner">
                          <div class="row">
                            <div class="dp-tb">
                              <p class="col-txt dp-tbc">
                                {{ $t('home_package.price') }}
                                <br class="d-block d-sm-none" />
                                <small
                                  v-if="$i18n.locale === 'en'"
                                >({{ $t('home_package.monthly') }})</small>
                              </p>
                              <p class="col-price dp-tbc">399.-</p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="dp-tb">
                              <p class="col-txt dp-tbc">
                                {{ $t('home_package.internet') }}
                                <br class="d-block d-sm-none" />
                                <small>({{ $t('home_package.nonstop') }})</small>
                              </p>
                              <p class="col-price net dp-tbc">
                                <small>{{ $t('home_package.unlimited') }}</small>
                                <br />10 Mbps
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-5">
                        <div class="wrap-inner">
                          <div class="row">
                            <div class="dp-tb">
                              <p class="col-txt dp-tbc d-table-cell d-lg-none">
                                {{ $t('home_package.price') }}
                                <br class="d-block d-sm-none" />
                                <small
                                  v-if="$i18n.locale === 'en'"
                                >({{ $t('home_package.monthly') }})</small>
                              </p>
                              <p class="col-price dp-tbc">499.-</p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="dp-tb">
                              <p class="col-txt dp-tbc d-table-cell d-lg-none">
                                {{ $t('home_package.internet') }}
                                <br />
                                <small>({{ $t('home_package.nonstop') }})</small>
                              </p>
                              <p class="col-price net dp-tbc d-align-middle">
                                <small>{{ $t('home_package.unlimited') }}</small>
                                <br />20 Mbps
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="check-coverage wow fadeInUp"
                      data-wow-duration="0.3s"
                      data-wow-delay="0.3s"
                      style="margin-bottom: 0.8rem; text-align: center;"
                    >
                      <div class="mt-2">
                        <button
                          class="btn-round"
                          style="background-color: #ed207b; color: #fff; border-color: #fff;"
                          @click="navigateToCheckService('package')"
                        >{{ $t('btn.checklocation') }}</button>
                      </div>
                    </div>

                    <div
                      class="small text-center"
                      style="padding-bottom: 1rem;"
                    >({{ $t('home_package.ps_1') }})</div>
                  </div>
                </div>

                <div class="row-btn wow zoomIn" data-wow-duration="0.7s" data-wow-delay="1.0s">
                  <p class="small text-center">* {{ $t('home_package.ps_2') }}</p>

                  <div
                    class="btn-tc"
                    style="cursor: pointer;"
                    @click="navigateToTermsAndConditions()"
                  >
                    {{ $t('btn.terms') }}
                    <i class="fa fa-plus"></i>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>


<script>
import "@/plugins/jquery";
import WOW from "wow.js";
// import '../assets/home/js/jquery-3.3.1.min'
// import '../assets/home/js/jquery.fancybox.pack'

export default {
  name: "home",
  methods: {
    navigateToCheckService: function(btn_position) {
      // this.$analytics.logEvent("home_checkavail_btn_click", {
      //   position: btn_position
      // });
      this.$logEvent(this.$analytics, "home_checkavail_btn_click", {
        position: btn_position
      });
      this.$router.push({ name: "checkservice" });
    },
    navigateToTermsAndConditions: function(btn_position) {
      // this.$analytics.logEvent("home_terms_btn_click", {
      //   position: btn_position
      // });
      this.$logEvent(this.$analytics, "home_terms_btn_click", {
        position: btn_position
      });
      this.$router.push({ name: "termsCond" });
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    //this.$analytics.logEvent("home_page_vist");
    this.$logEvent(this.$analytics, "home_page_visit");

    new WOW().init();
    /* eslint-disable no-undef */
    $(".faqs li header").on("click", function(e) {
      e.preventDefault();
      $(this)
        .parent("li")
        .siblings()
        .find(".content")
        .slideUp();
      $(this)
        .parent("li")
        .siblings()
        .removeClass("active");
      $(this)
        .parent("li")
        .toggleClass("active");
      $(this)
        .next(".content")
        .slideToggle();
    });
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/bootstrap";
@import "../assets/home/css/animate.css";
@import "../assets/home/css/plug_in.css";
@import "../assets/home/css/style.css";

.faqs .topic-title {
  font-size: 1.3rem;
  padding: 1.5rem 0 1rem 0;
  color: #009de0;
}

.main-hl .hl-txt .check-coverage {
  margin-top: 1rem;
  color: #fff;
  font-size: 1.3rem;
  text-align: center;

  .text {
    color: #ed207b;
    text-shadow: rgba(255, 255, 255, 1) 2px 0 0,
      rgba(255, 255, 255, 1) 1.75517px 0.958851px 0,
      rgba(255, 255, 255, 1) 1.0806px 1.68294px 0,
      rgba(255, 255, 255, 1) 0.141474px 1.99499px 0,
      rgba(255, 255, 255, 1) -0.832294px 1.81859px 0,
      rgba(255, 255, 255, 1) -1.60229px 1.19694px 0,
      rgba(255, 255, 255, 1) -1.97998px 0.28224px 0,
      rgba(255, 255, 255, 1) -1.87291px -0.701566px 0px,
      rgba(255, 255, 255, 1) -1.30729px -1.5136px 0px,
      rgba(255, 255, 255, 1) -0.421592px -1.95506px 0px,
      rgba(255, 255, 255, 1) 0.567324px -1.91785px 0px,
      rgba(255, 255, 255, 1) 1.41734px -1.41108px 0px,
      rgba(255, 255, 255, 1) 1.92034px -0.558831px 0px;

    @include media-breakpoint-up(lg) {
      font-size: 1.5rem;
    }
  }

  .btn-round {
    border-color: #fff;
    background-color: #ed207b;
    color: #fff;
    font-size: 1.5rem;
    padding: 0.2rem 2.3rem;
  }
}
.en .main-hl .hl-txt .check-coverage .btn-round {
  font-size: 1.2rem;
}

@include media-breakpoint-up(lg) {
  .btn-check-coverage {
    font-size: 1.6rem;
  }
  .en .btn-check-coverage {
    font-size: 1.3rem;
  }
}

@include media-breakpoint-down(md) {
  .main-hl .hl-detail .box-home .start-pack-plan img {
    max-width: 100% !important;
  }
  .en .main-hl .hl-detail .box-detail > ul li .wrap-inner h3 {
    font-size: 10px;
  }
  .en .main-hl .hl-txt {
    padding-bottom: 70px;
  }
}

.plan-package .obj-man {
  background-image: url("../assets/home/images/obj-man-wifi2.png");
}
.plan-package .obj-women {
  background-image: url("../assets/home/images/obj-women-wifi2.png");
}

.why-wrapper {
  > .row {
    margin-top: 3.5rem;
  }
  .embed-responsive {
    align-self: center;
  }
  .install,
  .lock-up,
  .money-back {
    padding: 1rem;
    border-radius: 1.5rem 0.5rem;
    background-color: #19aaf8;
    color: #fff;
    box-shadow: 3px 4px 0 1px #ffdf02;

    h3,
    h4 {
      color: #26ace2;
      text-shadow: rgb(255, 255, 255) 3px 0px 0px,
        rgb(255, 255, 255) 2.83487px 0.981584px 0px,
        rgb(255, 255, 255) 2.35766px 1.85511px 0px,
        rgb(255, 255, 255) 1.62091px 2.52441px 0px,
        rgb(255, 255, 255) 0.705713px 2.91581px 0px,
        rgb(255, 255, 255) -0.287171px 2.98622px 0px,
        rgb(255, 255, 255) -1.24844px 2.72789px 0px,
        rgb(255, 255, 255) -2.07227px 2.16926px 0px,
        rgb(255, 255, 255) -2.66798px 1.37182px 0px,
        rgb(255, 255, 255) -2.96998px 0.42336px 0px,
        rgb(255, 255, 255) -2.94502px -0.571704px 0px,
        rgb(255, 255, 255) -2.59586px -1.50383px 0px,
        rgb(255, 255, 255) -1.96093px -2.27041px 0px,
        rgb(255, 255, 255) -1.11013px -2.78704px 0px,
        rgb(255, 255, 255) -0.137119px -2.99686px 0px,
        rgb(255, 255, 255) 0.850987px -2.87677px 0px,
        rgb(255, 255, 255) 1.74541px -2.43999px 0px,
        rgb(255, 255, 255) 2.44769px -1.73459px 0px,
        rgb(255, 255, 255) 2.88051px -0.838247px 0px;
    }
    p {
      font-weight: 400;
    }
    .wrap-inner {
      background-repeat: no-repeat;
      background-position: center right;
      background-size: 10%;
      padding-right: 4rem;
    }
  }

  .install .wrap-inner {
    background-image: url("../assets/home/images/ico-install@2x.png");
    background-size: 8%;
  }
  .lock-up .wrap-inner {
    background-image: url("../assets/home/images/ico-worth@2x.png");
  }
  .money-back .wrap-inner {
    background-image: url("../assets/home/images/ico-guarantee@2x.png");
  }
}
/*
  .why>ul>li.install .wrap-inner {
    background-image: url('../assets/home/images/ico-install@2x.png');
  }
  .why>ul>li.lock-up .wrap-inner {
    background-image: url('../assets/home/images/ico-worth@2x.png');
  }
  .why>ul>li.money-back .wrap-inner {
    background-image: url('../assets/home/images/ico-guarantee@2x.png');
  }
   */

.plan-package header h3 {
  margin-bottom: 10px;
  padding-top: 10px;
}
.plan-package .detail {
  z-index: 100;
}
.plan-package .obj-man {
  background-image: url("../assets/home/images/obj-man-wifi2.png");
  /*width: 305px;*/
  /*left: -325px;*/
  /*height: 442px;*/
}
.plan-package .obj-women {
  background-image: url("../assets/home/images/obj-women-wifi2.png");
  /*width: 213px;*/
  /*height: 452px;*/
  /*right: -250px;*/
}
.device .box-device [class*="col-"].pro .detail:after {
  background-image: url("../assets/home/images/obj-boy.png");
}
.device .box-device [class*="col-"].basic figure:after {
  background: url(../assets/home/images/obj-circle-model-basic.png) top center
    no-repeat;
  background-size: cover;
}

.main-hl .hl-detail .box-home .start-pack-plan {
  position: absolute;
  bottom: -100px;
  right: -72px;
  text-align: center;
  width: 160px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (min-width: 1441px) {
    bottom: -40px;
  }

  img {
    /*max-width: 160px;*/
  }
  p {
    margin-bottom: 0;
    &.title {
      font-size: 1.1rem;
      line-height: 1.3;
    }
  }

  .note {
    color: #fff;
    font-size: 0.8rem;
  }

  .price {
    font-size: 3rem;
    line-height: 1;
    font-weight: bold;
    font-style: italic;
    display: inline-block;
    border-bottom: 2px solid #08296c;

    small {
      font-size: 55%;
      font-weight: bold;
    }
  }

  .prepaid {
    color: #08296c;
    padding-left: 12px;
  }
  .postpaid {
    padding-right: 12px;
    padding-left: 4px;
  }

  @include media-breakpoint-down(lg) {
    width: 110px;
    bottom: -43px;
    right: -65px;

    .note {
      font-size: 0.6rem;
    }
  }

  @include media-breakpoint-down(md) {
    right: -105px;
  }

  @include media-breakpoint-down(xs) {
    right: 0;
    bottom: -28px;
    width: 75px;

    .note {
      font-size: 6px;
    }
  }
}

//Fix Very Small device like iPhone 5
@media screen and (max-width: 320px) {
  .main-hl .hl-detail .box-home .start-pack-plan {
    justify-content: start;
    top: -60px;
    right: 55px;
  }
}

.plan-package {
  header {
    position: relative;
    z-index: 3;
    border-radius: 20px;
    border-top-right-radius: 0;
    margin-left: -15px;
    margin-right: -15px;
    padding: 14px 0;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);

    h3,
    p {
      padding: 0;
      margin: 0;
      color: #fff;
    }
  }
  .detail {
    margin-top: -5px;
    position: relative;
    z-index: 1;
    border-radius: 0 0 15px 15px;
    background-color: rgba(#ef4d84, 0.25);
  }
  .device {
    margin: 20px 0;
    border-radius: 20px;

    .wrap-inner {
      display: inline-block;

      @include media-breakpoint-up(md) {
        margin-left: -40px;
      }

      &::after {
        content: none !important;
      }
    }

    figure {
      margin: 0;
      > img {
        max-width: 200px;

        @include media-breakpoint-down(md) {
          max-width: 150px;
        }
      }
    }
    .model {
      position: relative;
      font-size: 1.3rem;
      font-weight: bold;
      margin-left: -40px;
      display: inline-block;

      @include media-breakpoint-up(sm) {
        display: block;
        &::after {
          content: "";
          border: 1px solid #fff;
          height: 160%;
          position: absolute;
          top: -30%;
          right: -15px;
        }
      }
      @include media-breakpoint-up(md) {
        font-size: 1.5rem;
        margin-left: -45px;
      }
    }
    .price,
    .special {
      margin-left: -1rem;
      padding: 0.7rem 0;
      line-height: 1.1;
      font-size: 1rem;

      .big {
        font-size: 2rem;
        font-weight: bold;
      }

      @include media-breakpoint-up(sm) {
        margin-left: 2rem;
        font-size: 1rem;
      }
    }
  }

  &.postpaid {
    header,
    .device {
      background-color: #ef4d84;
    }
    .device {
      color: #fff;
    }
  }
  &.prepaid {
    header,
    .device {
      background-color: #ffde2f;
    }
    header {
      h3,
      p {
        color: #004c97;
      }
    }
    .device {
      color: #004c97;

      @include media-breakpoint-down(md) {
        flex-flow: row wrap;
      }
    }
    .detail {
      background-color: rgba(#ffde2f, 0.25);

      @include media-breakpoint-down(md) {
        .row.no-gutters {
          .wrap-inner {
            display: flex;
            flex-direction: row;
            border-bottom: 2px solid #bcbec0;

            > .row {
              flex: 1 1 auto;
              &:first-child {
                border-bottom: none;
              }
            }
          }
        }
      }
    }
    .special {
      background-color: #004c97;
      color: #fff;
      padding: 10px;
      border-radius: 10px;
      margin-left: 1rem;

      @include media-breakpoint-down(md) {
        margin: 0.75rem 0;
      }

      .free-net {
        padding: 5px;
        border-radius: 5px;
        background-color: #fff;
        color: #004c97;
      }
    }
  }
}
</style>
